import { render, staticRenderFns } from "./RequistionForm.vue?vue&type=template&id=b17275ae"
import script from "./RequistionForm.vue?vue&type=script&lang=js"
export * from "./RequistionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports